/**
 * De groene balk tijdens een gesprek (ontwerp v4 §9).
 *
 * Naam als link naar de klantpagina, nummer, een lopende teller,
 * Notitie en Klantpagina. **Geen Dempen en geen Ophangen**: JP heeft op
 * 21-09 geantwoord dat Rinkel die twee niet via de API aanbiedt. Dan
 * laten we ze weg in plaats van ze grijs te tonen — een knop die er
 * staat maar nooit kan is erger dan geen knop.
 *
 * De balk is gewone flow, geen overlay: het portaal eronder blijft
 * bedienbaar zonder dat er een z-index-gevecht of een focusval voor
 * nodig is.
 */
import { useEffect, useState } from "react";

import type { BelGestart } from "@/lib/werkplek-api";

interface Props {
  gesprek: BelGestart;
  /** Klik op de naam of op Klantpagina. */
  onKlantpagina?: (klantId: string) => void;
  /** Klik op Notitie: springt naar de Notitie-tab van de tegel. */
  onNotitie?: () => void;
  /** De balk sluiten als het gesprek afgelopen is. */
  onSluiten?: () => void;
}

/** mm:ss sinds de start van het gesprek. */
function teller(startOp: string, nu: number): string {
  const seconden = Math.max(
    0,
    Math.floor((nu - new Date(startOp).getTime()) / 1000),
  );
  const m = Math.floor(seconden / 60);
  const s = seconden % 60;
  return `${m < 10 ? "0" : ""}${m}:${s < 10 ? "0" : ""}${s}`;
}

export function Belbalk({
  gesprek,
  onKlantpagina,
  onNotitie,
  onSluiten,
}: Props) {
  const [nu, setNu] = useState(() => Date.now());

  useEffect(() => {
    const tik = window.setInterval(() => setNu(Date.now()), 1000);
    return () => window.clearInterval(tik);
  }, []);

  const naam = gesprek.klant_naam ?? "onbekende beller";

  return (
    <div className="wp-belbalk" role="status" aria-live="polite">
      <span style={{ fontWeight: 600 }}>
        In gesprek met{" "}
        {gesprek.klant_id && onKlantpagina ? (
          <button
            type="button"
            className="wp-knop wp-tegel-knop-klein"
            onClick={() => onKlantpagina(gesprek.klant_id as string)}
          >
            {naam}
          </button>
        ) : (
          naam
        )}
      </span>
      <span style={{ color: "var(--wp-tekst2)" }}>
        {gesprek.nummer} · via Rinkel op je mobiel
      </span>
      <span className="wp-belbalk-tijd" aria-label="Gespreksduur">
        {teller(gesprek.gestart_op, nu)}
      </span>
      <div className="wp-belbalk-rechts">
        <button
          type="button"
          className="wp-knop wp-tegel-knop-klein"
          onClick={onNotitie}
        >
          Notitie
        </button>
        {gesprek.klant_id && onKlantpagina ? (
          <button
            type="button"
            className="wp-knop wp-tegel-knop-klein"
            onClick={() => onKlantpagina(gesprek.klant_id as string)}
          >
            Klantpagina
          </button>
        ) : null}
        <button
          type="button"
          className="wp-knop wp-tegel-knop-klein"
          onClick={onSluiten}
        >
          Balk sluiten
        </button>
      </div>
    </div>
  );
}
